import { InjectionToken } from '@angular/core';

/** Full-page navigation (leaves the SPA); a token so tests can observe it. */
export const NAVIGATE = new InjectionToken<(url: string) => void>('NAVIGATE', {
  providedIn: 'root',
  factory: () => (url: string) => {
    window.location.href = url;
  },
});
